import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { AxiosResponse } from 'axios'
import { IOperationEventResponse } from 'types/api/operationsAimApi.interface'
import { IPaginatedResponse } from 'types/api/general.interface'
import { IOpsEventsSlice } from 'types/opsEvents.interface'
import { baseUrl } from 'utils/axios'
import { handleErrors } from 'utils/helpers'
import { mapEvent } from 'pages/Operations/Shared/opsApiMappers'
import { USE_OPS_MOCKS } from 'pages/Operations/Shared/opsControl'
import { demoOpsEvents } from 'pages/Operations/Shared/opsApiDemoCore'

const initialState: IOpsEventsSlice = {
  isLoading: false,
  events: [],
  totalCount: 0,
  totalPages: 0,
  page: 1,
}

export const getOpsEvents = createAsyncThunk(
  'opsEvents/getOpsEvents',
  async (params: any, thunkAPI) => {
    if (USE_OPS_MOCKS) return demoOpsEvents()
    try {
      const resp: AxiosResponse<IPaginatedResponse<IOperationEventResponse>> = await baseUrl.get(
        'aim-operations/events',
        { params },
      )
      return resp.data
    } catch (error) {
      return thunkAPI.rejectWithValue(error)
    }
  },
)

const opsEventsSlice = createSlice({
  name: 'opsEvents',
  initialState,
  reducers: {
    clearOpsEvents: (state) => {
      state.events = []
      state.totalCount = 0
      state.totalPages = 0
    },
  },
  extraReducers: {
    [getOpsEvents.pending.type]: (state) => {
      state.isLoading = true
    },
    [getOpsEvents.fulfilled.type]: (
      state,
      { payload }: { payload: IPaginatedResponse<IOperationEventResponse> },
    ) => {
      state.isLoading = false
      state.events = (payload.data || []).map(mapEvent)
      state.totalCount = payload.totalCount
      state.totalPages = payload.totalPages
    },
    [getOpsEvents.rejected.type]: (state, action) => {
      state.isLoading = false
      handleErrors(action.payload)
    },
  },
})

export const { clearOpsEvents } = opsEventsSlice.actions
export default opsEventsSlice.reducer
